export default __webpack_public_path__ + "static/media/bg1.b20b5732.svg";